<template>
  <div ref="body"  @click="closeSelectList">
    <custom-header active="service" :subActive="current"></custom-header>

    <div class="content-container-form ">
      <h1>Overseas Buyer Requirement Survey</h1>
      
      <p>Dear Buyer,</p>
      <p>Thank you for your interest in Shenzhen International Furniture Exhibition.</p>
      <p>To better understand your business needs and provide suitable supplier recommendations, please complete the following short survey.</p>

      <div class="sectionPart">Part 1. Your Contact Information</div>

      <div class="section">
        <div class="title">1.1. Full Name<span class="text-red">*</span></div>
        <el-input v-model="form.name" placeholder="Full Name" class="form-input"></el-input> 
        <div v-if="!form.name" class="error-msg">
          <span class="error-tips text-red">Please Input</span>
        </div>

        <div class="title">1.2. Job Title / Position<span class="text-red">*</span></div>
        <div class="row">
          <el-radio-group v-model="form.job_title" style="width: 100%;">
            <el-radio label="Owner / Founder"></el-radio>
            <el-radio label="Purchasing Manager / Buyer"></el-radio>
            <el-radio label="Distributor / Wholesaler Manager"></el-radio>
            <el-radio label="Retail Manager"></el-radio>
            <el-radio label="Designer / Interior Designer"></el-radio>
            <el-radio label="Architect"></el-radio>
            <el-radio label="Project Manager"></el-radio>
            <el-radio label="Hotel / Real Estate Developer"></el-radio>
            <el-radio label="Other"></el-radio>
          </el-radio-group>
        </div>
        <div v-if="form.job_title === 'Other'" class="other-box errorMsgleft">
          <input type="text" v-model="form.job_title_other" class="other-input" placeholder="Please enter your job title">
        </div>
        <div v-if="!form.job_title" class="error-msg">
          <span class="error-tips text-red">Please select</span>
        </div>

        <div class="title">1.3. Company Name<span class="text-red">*</span></div>
        <el-input v-model="form.companyName" placeholder="Company Name" class="form-input"></el-input>
        <div v-if="!form.companyName" class="error-msg">
          <span class="error-tips text-red">Please Input</span>
        </div>

        <div class="title">1.4. Email Address<span class="text-red">*</span></div>
        <el-input v-model="form.email" placeholder="Email Address" class="form-input"></el-input>
        <div v-if="!form.email" class="error-msg">
          <span class="error-tips text-red">Please Input</span>
        </div>
 
        <div class="title">1.5. Country / Region<span class="text-red">*</span></div>
        <el-select v-model="form.country" placeholder="Please select" filterable @change="onCountryChange" class="form-select">
          <el-option v-for="country in countryList" :key="country.national_code" :label="country.area_name" :value="country.area_name"></el-option>
        </el-select>
        <div v-if="!form.country" class="error-msg">
          <span class="error-tips text-red">Please select</span>
        </div>

        <div class="title">1.6. WhatsApp Number<span class="text-red">*</span></div>
        <div class="phone-input-wrapper">
          <el-input v-model="form.whatsapp_code" disabled class="phone-code-select" placeholder="Code">
            <!-- <template slot="prepend">+</template> -->
          </el-input>
          <el-input v-model="form.whatsapp_number" placeholder="Phone Number" class="phone-number-input"></el-input>
        </div>
        <div v-if="!form.whatsapp_code || !form.whatsapp_number" class="error-msg">
          <span class="error-tips text-red">Please Input</span>
        </div>

        <div class="title">1.7. Website / Social Media (Optional)</div>
        <el-input v-model="form.website" placeholder="Website / Social Media (Optional)" class="form-input"></el-input>
      </div>

      <div class="sectionPart">Part 2. Your Business Information</div>
      <div class="section">
        <div class="title">
          <span>2.1. What is your business type? (Single Choice)</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-radio-group v-model="form.business_type" style="width: 100%;">
            <el-radio label="Furniture Distributor / Wholesaler"></el-radio>
            <el-radio label="Furniture Retailer / Importer"></el-radio>
            <el-radio label="Interior Designer / Design Studio"></el-radio>
            <el-radio label="Architect / Project Company"></el-radio>
            <el-radio label="Hotel / Real Estate Developer"></el-radio>
            <el-radio label="E-commerce Seller"></el-radio>
            <el-radio label="Looking for Business Partner"></el-radio>
            <el-radio label="Other"></el-radio>
          </el-radio-group>
        </div> 
        <div v-if="form.business_type == 'Other'" class="other-box errorMsgleft">
          <input type="text" v-model="form.business_type_other" class="other-input">
        </div>
      </div>
      <div v-if="(!form.business_type && form.business_type != 'Other') ||(form.business_type == 'Other' && !form.business_type_other)" class="errorMsgleft">
          <span class="error-tips text-red">Please Input</span>
        </div>

      <div class="sectionPart">Part 3. Your Requirement</div>
      
      <!-- A类: Owner/Founder, Purchasing Manager, Distributor, Retail Manager -->
      <div class="section" v-if="jobCategory === 'A'">
        <div class="title">
          <span>3.1. What furniture products are you interested in? (Multiple Choice)</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-checkbox-group v-model="form.your_requirement" style="width: 100%;">
            <el-checkbox label="Living & Dining Furniture"></el-checkbox>
            <el-checkbox label="Bedroom Furniture"></el-checkbox>
            <el-checkbox label="Office Furniture"></el-checkbox>
            <el-checkbox label="Hotel & Project Furniture"></el-checkbox>
            <el-checkbox label="Outdoor Furniture"></el-checkbox>
            <el-checkbox label="Smart Home / AI Furniture"></el-checkbox>
            <el-checkbox label="Customized Furniture"></el-checkbox>
            <el-checkbox label="Health, Eco-friendly & Sustainable Home Products / Building Materials" class="full-width"></el-checkbox>
            <el-checkbox label="Original Design Furniture"></el-checkbox>
            <el-checkbox label="Other"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="containOtherItem(form.your_requirement)" class="other-box errorMsgleft"> 
          <input type="text" v-model="form.your_requirement_other" class="other-input">
        </div>
        <div class="errorMsgleft">
          <span v-if="form.your_requirement.length == 0" class="error-tips text-red">Please Select</span>
          <span v-if="containOtherItem(form.your_requirement) && !form.your_requirement_other" class="error-tips text-red">Please Input</span>
        </div>

        <div class="title">
          <span>3.2. What is your purchasing plan?</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-radio-group v-model="form.your_purchasing_plan" style="width: 100%;">
            <el-radio label="Looking for new suppliers now"></el-radio>
            <el-radio label="Have upcoming purchase projects"></el-radio>
            <el-radio label="Looking for long-term cooperation"></el-radio>
            <el-radio label="Just exploring suppliers"></el-radio>
          </el-radio-group>
        </div>
        <div v-if="!form.your_purchasing_plan" class="errorMsgleft">
          <span class="error-tips text-red">Please select</span>
        </div>

        <div class="title">
          <span>3.3. What is your project type? (Multiple Choice)</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-checkbox-group v-model="form.your_project_type" style="width: 100%;">
            <el-checkbox label="Residential / Villa"></el-checkbox>
            <el-checkbox label="Hotel / Resort"></el-checkbox>
            <el-checkbox label="Office / Commercial Space"></el-checkbox>
            <el-checkbox label="Other"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="containOtherItem(form.your_project_type)" class="other-box errorMsgleft">
          <input type="text" v-model="form.your_project_type_other" class="other-input">
        </div>
        <div class="errorMsgleft">
          <span v-if="form.your_project_type.length == 0" class="error-tips text-red">Please Select</span>
          <span v-if="containOtherItem(form.your_project_type) && !form.your_project_type_other" class="error-tips text-red">Please Input</span>
        </div>

        <div class="title">
          <span>3.4. Estimated Project Budget</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-radio-group v-model="form.budget" style="width: 100%;">
            <el-radio label="Below USD 100,000"></el-radio>
            <el-radio label="USD 100,000 - 500,000"></el-radio>
            <el-radio label="Above USD 500,000"></el-radio>
          </el-radio-group>
        </div>
      </div>
      <div v-if="jobCategory === 'A' && !form.budget" class="errorMsgleft">
        <span class="error-tips text-red">Please select</span>
      </div>

      <!-- B类: Designer / Interior Designer, Architect -->
      <div class="section" v-if="jobCategory === 'B'">
        <div class="title">
          <span>3.1. What type of projects are you working on? (Multiple Choice)</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-checkbox-group v-model="form.b_project_type" style="width: 100%;">
            <el-checkbox label="Residential / Villa"></el-checkbox>
            <el-checkbox label="Apartment / Housing Project"></el-checkbox>
            <el-checkbox label="Hotel / Resort"></el-checkbox>
            <el-checkbox label="Restaurant / Hospitality"></el-checkbox>
            <el-checkbox label="Office / Commercial Space"></el-checkbox>
            <el-checkbox label="Retail Space"></el-checkbox>
            <el-checkbox label="Other"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="containOtherItem(form.b_project_type)" class="other-box errorMsgleft">
          <input type="text" v-model="form.b_project_type_other" class="other-input">
        </div>
        <div class="errorMsgleft">
          <span v-if="form.b_project_type.length == 0" class="error-tips text-red">Please Select</span>
          <span v-if="containOtherItem(form.b_project_type) && !form.b_project_type_other" class="error-tips text-red">Please Input</span>
        </div>

        <div class="title">
          <span>3.2. Project Location (Country / City)</span>
          <span class="text-red">*</span>
        </div>
        <el-input v-model="form.b_project_location" placeholder="e.g. China / Shenzhen" class="form-input"></el-input>
        <div v-if="!form.b_project_location" class="error-msg">
          <span class="error-tips text-red">Please Input</span>
        </div>

        <div class="title">
          <span>3.3. Estimated Project Budget</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-radio-group v-model="form.budget" style="width: 100%;">
            <el-radio label="Below USD 100,000"></el-radio>
            <el-radio label="USD 100,000 - 500,000"></el-radio>
            <el-radio label="USD 500,000 - 1 Million"></el-radio>
            <el-radio label="Above USD 1 Million"></el-radio>
          </el-radio-group>
        </div>
        <div v-if="!form.budget" class="errorMsgleft">
          <span class="error-tips text-red">Please select</span>
        </div>

        <div class="title">
          <span>3.4. What kind of furniture support do you need? (Multiple Choice)</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-checkbox-group v-model="form.b_furniture_support" style="width: 100%;">
            <el-checkbox label="Furniture sourcing support"></el-checkbox>
            <el-checkbox label="Customized furniture development"></el-checkbox>
            <el-checkbox label="Complete furniture package solution"></el-checkbox>
            <el-checkbox label="Design collaboration"></el-checkbox>
            <el-checkbox label="Factory recommendation"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="errorMsgleft">
          <span v-if="form.b_furniture_support.length == 0" class="error-tips text-red">Please Select</span>
        </div>
      </div>

      <!-- C类: Project Manager, Hotel / Real Estate Developer -->
      <div class="section" v-if="jobCategory === 'C'">
        <div class="title">
          <span>3.1. Project Type (Multiple Choice)</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-checkbox-group v-model="form.c_project_type" style="width: 100%;">
            <el-checkbox label="Hotel"></el-checkbox>
            <el-checkbox label="Resort"></el-checkbox>
            <el-checkbox label="Residential Development"></el-checkbox>
            <el-checkbox label="Commercial Building"></el-checkbox>
            <el-checkbox label="Office Project"></el-checkbox>
            <el-checkbox label="Other"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="containOtherItem(form.c_project_type)" class="other-box errorMsgleft">
          <input type="text" v-model="form.c_project_type_other" class="other-input">
        </div>
        <div class="errorMsgleft">
          <span v-if="form.c_project_type.length == 0" class="error-tips text-red">Please Select</span>
          <span v-if="containOtherItem(form.c_project_type) && !form.c_project_type_other" class="error-tips text-red">Please Input</span>
        </div>

        <div class="title">
          <span>3.2. Project Stage (Multiple Choice)</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-checkbox-group v-model="form.c_project_stage" style="width: 100%;">
            <el-checkbox label="Planning Stage"></el-checkbox>
            <el-checkbox label="Design Stage"></el-checkbox>
            <el-checkbox label="Purchasing Stage"></el-checkbox>
            <el-checkbox label="Under Construction"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="errorMsgleft">
          <span v-if="form.c_project_stage.length == 0" class="error-tips text-red">Please Select</span>
        </div>

        <div class="title">
          <span>3.3. Procurement Requirement (Multiple Choice)</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-checkbox-group v-model="form.c_procurement" style="width: 100%;">
            <el-checkbox label="Full furniture package"></el-checkbox>
            <el-checkbox label="Loose furniture"></el-checkbox>
            <el-checkbox label="Customized furniture"></el-checkbox>
            <el-checkbox label="FF&E sourcing"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="errorMsgleft">
          <span v-if="form.c_procurement.length == 0" class="error-tips text-red">Please Select</span>
        </div>

        <div class="title">
          <span>3.4. Estimated Project Budget</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-radio-group v-model="form.c_budget" style="width: 100%;">
            <el-radio label="Below USD 500,000"></el-radio>
            <el-radio label="USD 500,000 - 2 Million"></el-radio>
            <el-radio label="USD 2 Million - 5 Million"></el-radio>
            <el-radio label="Above USD 5 Million"></el-radio>
          </el-radio-group>
        </div>
        <div v-if="!form.c_budget" class="errorMsgleft">
          <span class="error-tips text-red">Please select</span>
        </div>
      </div>
     

      <!-- E类: Other -->
      <div class="section" v-if="jobCategory === 'E'">
        <div class="title">
          <span>3.1. What furniture products are you interested in?</span>
          <span class="text-red">*</span>
        </div>
        <el-input v-model="form.e_furniture_interest" placeholder="Please describe the furniture products you are interested in" class="form-input"></el-input>
        <div v-if="!form.e_furniture_interest" class="error-msg">
          <span class="error-tips text-red">Please Input</span>
        </div>

        <div class="title">
          <span>3.2. What is your project type?</span>
          <span class="text-red">*</span>
        </div>
        <el-input v-model="form.e_project_type" placeholder="Please describe your project type" class="form-input"></el-input>
        <div v-if="!form.e_project_type" class="error-msg">
          <span class="error-tips text-red">Please Input</span>
        </div>
      </div>  

      <div class="sectionPart">Part 4. Cooperation & Exhibition Plan</div>
      <div class="section">
        <div class="title">
          <span>4.1. What kind of cooperation are you looking for? (Multiple Choice)</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-checkbox-group v-model="form.cooperation_type" style="width: 100%;">
            <el-checkbox label="Purchasing furniture from China"></el-checkbox>
            <el-checkbox label="Finding furniture suppliers"></el-checkbox>
            <el-checkbox label="Project cooperation"></el-checkbox>
            <el-checkbox label="Furniture distribution opportunity"></el-checkbox>
            <el-checkbox label="Other"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="containOtherItem(form.cooperation_type)" class="other-box errorMsgleft"> 
          <input type="text" v-model="form.cooperation_type_other" class="other-input">
        </div>
        <div class="errorMsgleft">
          <span v-if="form.cooperation_type.length == 0" class="error-tips text-red">Please Select</span>
          <span v-if="containOtherItem(form.cooperation_type) && !form.cooperation_type_other" class="error-tips text-red">Please Input</span>
        </div>

        <div class="title">
          <span>4.2. Are you planning to visit Shenzhen International Furniture Exhibition 2027?</span>
          <span class="text-red">*</span>
        </div>
        <div class="row">
          <el-radio-group v-model="form.planning_to_visit_szcw" style="width: 100%;">
            <el-radio label="Yes, I plan to attend"></el-radio>
            <el-radio label="Interested, need more information"></el-radio>
            <el-radio label="Not decided yet"></el-radio>
          </el-radio-group> 
        </div>
        <div v-if="!form.planning_to_visit_szcw" class="errorMsgleft">
          <span class="error-tips text-red">Please select</span>
        </div> 

        <div class="title">
          <span>4.3. Would you like to receive exhibition updates and supplier recommendations by email?</span>
          <span class="text-red">*</span>
        </div>
        <div class="row"> 
          <el-radio-group v-model="form.receive_email" style="width: 100%;">
            <el-radio label="Yes"></el-radio>
            <el-radio label="No"></el-radio>
          </el-radio-group> 
        </div>
         <div v-if="!form.receive_email" class="errorMsgleft">
          <span class="error-tips text-red">Please select</span>
        </div> 
      </div>
      <button class="submit-btn" @click="submit">Submit</button>
    </div>
    
    <custom-footer :friendLink="friendLink"></custom-footer>
    
    <scroll-top @scrollTop="scrollTop"></scroll-top>
  </div>
</template>

<script>
import { Toast } from 'vant';
import customHeader from "./components/head.vue";
import customFooter from "./components/foot.vue";
import scrollTop from "./components/scrollTop.vue";
import commonMixin from './commonMixin.js';
import countryList from '../utils/countrys.js';
import { submitSourcing } from '@/api/index.js';

export default {
  components: {
    'custom-header': customHeader,
    'custom-footer': customFooter, 
    'scroll-top': scrollTop,
  },
  mixins: [commonMixin],
  metaInfo: {
    title: 'Shenzhen World Furniture Exhibition: Sourcing Request Form',
    meta: [
      { name: 'keyWords', content: 'Furniture Fair,Home Design,Furniture Exhibitor,Home Furnishing Forum,Design Week,Home Design Week' },
      { name: 'description', content: 'Submit Sourcing Request for 39th Shenzhen International Furniture Exhibition. Choose the Category, Purpose, and Share Your Contact Info With Relevant Suppliers.'},
    ],
  },
  data() {
    return {
      current: 'sourcing',
      countryList:[],
      form: {
        name:'',
        job_title:'',
        job_title_other:'',
        companyName:'',
        email:'',
        whatsapp_code:'',
        whatsapp_number:'',
        country:'',
        countryCode:'',
        website:'',
        business_type:'',
        business_type_other:'',
        your_requirement :[],
        your_requirement_other:'',
        your_purchasing_plan:[],
        your_project_type  :[],
        your_project_type_other:'',
        budget:'',
        cooperation_type  :[],
        cooperation_type_other:'', 
        planning_to_visit_szcw:'',
        receive_email:'',
        // B类字段
        b_project_type:[],
        b_project_type_other:'',
        b_project_location:'',
        b_furniture_support:[],
        b_furniture_support_other:'',
        // C类字段
        c_project_type:[],
        c_project_type_other:'',
        c_project_stage:[],
        c_procurement:[],
        c_budget:'', 
        // E类字段
        e_furniture_interest:'',
        e_project_type:'',
      },
    }
  },
  computed: {
    jobCategory() {
      const title = this.form.job_title;
      if (!title) return 'A';
      const categoryMap = {
        'Owner / Founder': 'A',
        'Purchasing Manager / Buyer': 'A',
        'Distributor / Wholesaler Manager': 'A',
        'Retail Manager': 'A',
        'Designer / Interior Designer': 'B',
        'Architect': 'B',
        'Project Manager': 'C',
        'Hotel / Real Estate Developer': 'C',
        'Other': 'E',
      };
      return categoryMap[title] || 'E';
    }
  },
  created() {
    this.getCountrys();
  },
  methods: {
    containOtherItem(items) {
      return items.includes('Other');
    },
    closeSelectList() {
      // Keep for future use
    },
    onCountryChange(val) {
      let selected = this.countryList.find(c => c.area_name === val);
      if (selected) {
        this.form.countryCode = selected.national_code;
        this.form.whatsapp_code = '+'+selected.national_code+'';
      }
    },
    getCountrys() {
      this.countryList = Object.freeze(countryList);
    },
    formatCountryLabel(country) {
      return '+' + country.national_code + ' ' + country.area_name;
    },
    submit() {
      if (this.form.name == null || this.form.name.length == 0 || 
          this.form.job_title == null || this.form.job_title.length == 0 ||
          this.form.companyName == null || this.form.companyName.length == 0 ||
          this.form.email == null || this.form.email.length == 0 ||
          !this.form.whatsapp_code || !this.form.whatsapp_number ||
          this.form.country == null || this.form.country.length == 0
      ) {
        return;
      }
      if (this.form.job_title === 'Other' && (!this.form.job_title_other || this.form.job_title_other.length === 0)) {
        return;
      }
      if (this.form.business_type == '' || this.form.business_type.length == 0) {
        return;
      }
      if (this.form.business_type == 'Other' && (this.form.business_type_other == '' || this.form.business_type_other.length == 0)) {
        return;
      }
      
      // Part 3 validation based on job category
      const cat = this.jobCategory;
      if (cat === 'A') {
        if (this.form.your_requirement.length==0 || this.containOtherItem(this.form.your_requirement) && (this.form.your_requirement_other == '' || this.form.your_requirement_other.length == 0)) {
          return;
        } 
        if (this.form.your_purchasing_plan == '' || this.form.your_purchasing_plan.length == 0) {
          return;
        }
        if (this.form.your_project_type.length==0 || this.containOtherItem(this.form.your_project_type) && (this.form.your_project_type_other == '' || this.form.your_project_type_other.length == 0)) {
          return;
        }  
        if (this.form.budget == '' || this.form.budget.length == 0) {
          return;
        }
      } else if (cat === 'B') {
        if (this.form.b_project_type.length==0 || this.containOtherItem(this.form.b_project_type) && (this.form.b_project_type_other == '' || this.form.b_project_type_other.length == 0)) {
          return;
        }
        if (this.form.b_project_location == '' || this.form.b_project_location.length == 0) {
          return;
        }
        if (this.form.budget == '' || this.form.budget.length == 0) {
          return;
        }
        if (this.form.b_furniture_support.length==0) {
          return;
        }
      } else if (cat === 'C') {
        if (this.form.c_project_type.length==0 || this.containOtherItem(this.form.c_project_type) && (this.form.c_project_type_other == '' || this.form.c_project_type_other.length == 0)) {
          return;
        }
        if (this.form.c_project_stage.length==0) {
          return;
        }
        if (this.form.c_procurement.length==0) {
          return;
        }
        if (this.form.c_budget == '' || this.form.c_budget.length == 0) {
          return;
        }
      } else if (cat === 'E') {
        if (this.form.e_furniture_interest == '' || this.form.e_furniture_interest.length == 0) {
          return;
        }
        if (this.form.e_project_type == '' || this.form.e_project_type.length == 0) {
          return;
        }
      }
      
      // Part 4 validation
      if (this.form.cooperation_type.length==0 || this.containOtherItem(this.form.cooperation_type) && (this.form.cooperation_type_other == '' || this.form.cooperation_type_other.length == 0)) {
        return;
      } 
      if (this.form.planning_to_visit_szcw == '' || this.form.planning_to_visit_szcw.length == 0) {
        return;
      }
      if (this.form.receive_email == '' || this.form.receive_email.length == 0) {
        return;
      }
      
      const submitData = {
        ...this.form,
        whatsapp: '+' + this.form.whatsapp_code + ' ' + this.form.whatsapp_number
      };
      
      submitSourcing(submitData).then(res => {
        if (res.resultStatus) {
          Toast('Submitted successfully')
        } else{
          Toast('Failed to submit')
        }
      })
    }
  },
}
</script>
<style>
.el-select-dropdown {
  .el-select-dropdown__item {
    font-size: 14px !important;
    line-height: 36px !important;
    height: 36px !important;
    padding: 0 14px !important;
  }
  
  .el-select-dropdown__wrap {
    max-height: 260px;
  }
}

@media screen and (min-width: 1024px) {
  .van-toast {
    padding: 16Px; 
    font-size: 14Px;
    line-height: 1.5;
  }
  
  .el-select-dropdown {
    .el-select-dropdown__item {
      font-size: 14Px !important;
      line-height: 36Px !important;
      height: 36Px !important;
      padding: 0 14Px !important;
    }
    
    .el-select-dropdown__wrap {
      max-height: 260Px;
    }
  }
}
</style>
<style scoped lang="less">
.text-red {
  color: #f56c6c;
}

@media screen and (max-width: 1023px) {
  .content-container-form {
    max-width: 750px;
    margin: 20px auto;
    padding: 0 20px;
    
    h1 {
      font-size: 22px;
      text-align: center;
      font-weight: 600;
      color: #303133;
      margin-bottom: 10px;
    }
    
    p {
      font-size: 14px;
      line-height: 1.8;
      color: #606266;
      margin-bottom: 10px;
    }
    
    .sectionPart {
      margin-top: 20px;
      margin-bottom: 12px;
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      border-left: 4px solid #409eff;
      padding-left: 10px;
    }

    .section {
      margin-bottom: 16px;
      font-size: 14px;
    }

    .title {
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 4px;
      color: #606266;
      line-height: 1.6;
    }
    
    .row {
      margin: 0;
    }
    
    .other-box {
      margin-top: 10px;
      
      .other-input {
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        padding: 0 12px;
        box-sizing: border-box;
        width: 100%;
        height: 36px;
        margin-top: 8px;
        font-size: 14px;
      }
    }
    
    .errorMsgleft {
      padding-left: 0;
      margin-top: 6px;
    }
    
    .error-tips {
      font-size: 12px;
      color: #f56c6c;
    }
    
    .form-input {
      margin: 0 !important;
    }
    
    .error-msg {
      margin-top: 4px;
      margin-bottom: 0;
    }
    
    /deep/ .el-input {
      margin: 0 !important;
    }
    
    /deep/ .el-input__inner {
      height: 40px !important;
      line-height: 40px !important;
      font-size: 14px;
      border-radius: 4px;
      border: 1px solid #dcdfe6 !important;
      padding: 0 12px !important;
    }
    
    /deep/ .el-radio-group {
      display: flex;
      flex-wrap: wrap;
      gap: 8px 16px;
      padding: 0;
      
      .el-radio {
        margin-right: 0;
        margin-bottom: 0;
        padding-left: 24px;
        font-size: 14px;
        
        .el-radio__input {
          .el-radio__inner {
            width: 16px;
            height: 16px;
            border: 2px solid #dcdfe6;
            background: #fff;
            transition: all 0.3s;
          }
          
          &.is-checked .el-radio__inner {
            background-color: #c8a45c !important;
            border-color: #c8a45c !important;
          }
          
          &.is-checked .el-radio__inner::after {
            border-color: #fff !important;
          }
        }
        
        &.is-checked .el-radio__label {
          color: #c8a45c !important;
          font-weight: 600;
        }
        
        .el-radio__label {
          padding-left: 6px;
          font-size: 14px;
          line-height: 20px;
          color: #606266;
        }
      }
    }
    
    /deep/ .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      gap: 8px 16px;
      padding: 0;
      
      .el-checkbox {
        margin-right: 0;
        margin-bottom: 0;
        padding-left: 24px;
        font-size: 14px;
        
        .el-checkbox__input {
          .el-checkbox__inner {
            width: 16px;
            height: 16px;
          }
        }
        
        .el-checkbox__label {
          padding-left: 6px;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    
    .form-select {
      width: 100% !important;
      
      /deep/ .el-input {
        position: relative;
      }
      
      /deep/ .el-input__inner {
        height: 40px !important;
        line-height: 40px !important;
        font-size: 14px !important;
        border-radius: 4px !important;
        border: 1px solid #dcdfe6 !important;
        padding: 0 30px 0 12px !important;
      }
      
      /deep/ .el-input__suffix {
        position: absolute !important;
        right: 8px !important;
        top: 0 !important;
        height: 40px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        line-height: 1 !important;
      }
      
      /deep/ .el-input__suffix .el-select-icon {
        transform-origin: center center !important;
        transition: transform 0.3s !important;
      }
      
      &.is-active /deep/ .el-input__suffix .el-select-icon,
      &.is-reverse /deep/ .el-input__suffix .el-select-icon {
        transform: rotate(180deg) !important;
      }
      
      &.is-active /deep/ .el-input__suffix,
      &.is-reverse /deep/ .el-input__suffix {
        top: 0 !important;
        height: 40px !important;
      }
    }
    
    .phone-input-wrapper {
      display: flex;
      gap: 8px;
      
      .phone-code-select {
        width: 140px !important;
        flex-shrink: 0;
        
        /deep/ .el-input__inner.is-disabled {
          background-color: #f5f7fa;
          color: #606266;
          -webkit-text-fill-color: #606266;
        }
        
        /deep/ .el-input-group__prepend {
          background-color: #f5f7fa;
          color: #606266;
          border-color: #dcdfe6;
        }
      }
      
      .phone-number-input {
        flex: 1;
      }
    }
    
    .submit-btn {
      display: block;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border: none;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      border-radius: 8px;
      padding: 14px 60px;
      margin: 30px auto;
      cursor: pointer;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
      transition: all 0.3s;
      
      &:active {
        transform: scale(0.98);
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .content-container-form {
    max-width: 800Px;
    margin: 30Px auto;
    padding: 40Px;
    background: #fff;
    border-radius: 12Px;
    box-shadow: 0 4Px 24Px rgba(0, 0, 0, 0.06);
    
    h1 {
      font-size: 28Px;
      text-align: center;
      font-weight: 600;
      color: #303133;
      margin-bottom: 12Px;
    }
    
    p {
      font-size: 14Px;
      line-height: 1.8;
      color: #606266;
      margin-bottom: 12Px;
    }
    
    .sectionPart {
      margin-top: 20Px;
      margin-bottom: 12Px;
      font-size: 20Px;
      font-weight: 600;
      color: #303133;
      border-left: 4Px solid #409eff;
      padding-left: 12Px;
    }

    .section {
      margin-bottom: 16Px;
      font-size: 14Px;
    }

    .title {
      font-size: 15Px;
      font-weight: 500;
      margin-bottom: 4Px;
      color: #606266;
      line-height: 1.6;
      
      .text-red {
        margin-left: 4Px;
      }
    }
    
    .row {
      display: block;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .other-box {
      margin-top: 8Px;
      
      .other-input {
        border-radius: 6Px;
        border: 1Px solid #dcdfe6;
        padding: 0 14Px;
        box-sizing: border-box;
        width: 100%;
        height: 38Px;
        margin-top: 4Px;
        font-size: 14Px;
      }
    }
    
    .errorMsgleft {
      padding-left: 0;
      margin-top: 4Px;
    }
    
    .error-tips {
      font-size: 12Px;
      color: #f56c6c;
    }
    
    .form-input {
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .error-msg {
      margin-top: 4Px;
      margin-bottom: 0;
      line-height: 1.4;
    }
    
    /deep/ .el-input {
      margin: 0 !important;
      padding: 0 !important;
      font-size: 14Px !important;
    }
    
    /deep/ .el-input__inner {
      height: 42Px !important;
      line-height: 42Px !important;
      font-size: 14Px;
      border-radius: 4Px;
      border: 1Px solid #dcdfe6 !important;
      padding: 0 14Px !important;
    }
    
    /deep/ .el-radio-group {
      display: grid;
      // grid-template-columns: repeat(auto-fill, minmax(220Px, 1fr));
      // gap: 12Px 24Px;
      padding: 0;
      
      .el-radio {
        margin-right: 0;
        margin-bottom: 0;
        padding-left: 28Px;
        font-size: 14Px;
        min-height: 32Px;
        line-height: 1.6;
        display: flex;
        align-items: flex-start;
        
        .el-radio__input {
          margin-right: 0;
          
          .el-radio__inner {
            width: 18Px;
            height: 18Px;
            border: 1Px solid #dcdfe6;
            border-radius: 50%;
            background: #fff;
            transition: all 0.3s;
          }
          
          &.is-checked .el-radio__inner {
            background-color: #c8a45c !important;
            border-color: #c8a45c !important;
          }
          
          &.is-checked .el-radio__inner::after {
            width: 6Px !important;
            height: 10Px !important;
            border-left: 2Px solid #fff !important;
            border-bottom: 2Px solid #fff !important;
            border-top: none !important;
            border-right: none !important;
            top: 2Px !important;
            left: 5Px !important;
            transform: rotate(45deg) !important;
            background: transparent !important;
          }
        }
        
        &.is-checked .el-radio__label {
          color: #c8a45c !important;
          font-weight: 600;
        }
        
        .el-radio__label {
          padding-left: 8Px;
          padding-top: 0;
          font-size: 14Px;
          line-height: 1.6;
          color: #606266;
        }
      }
    }
    
    /deep/ .el-checkbox-group {
      display: grid;
      // grid-template-columns: repeat(auto-fill, minmax(220Px, 1fr));
      // gap: 12Px 24Px;
      padding: 0;
      
      .el-checkbox {
        margin-right: 0;
        margin-bottom: 0;
        padding-left: 28Px;
        font-size: 14Px;
        min-height: 32Px;
        line-height: 1.6;
        display: flex;
        align-items: flex-start;
        word-break: break-word;
        
        &.full-width {
          grid-column: 1 / -1;
        }
        
        .el-checkbox__input {
          margin-right: 0;
          
          .el-checkbox__inner {
            width: 18Px;
            height: 18Px;
            border: 1Px solid #dcdfe6;
            border-radius: 2Px;
            background: #fff;
          }
          
          &.is-checked .el-checkbox__inner {
            background-color: #c8a45c !important;
            border-color: #c8a45c !important;
          }
          
          &.is-checked .el-checkbox__inner::after {
            border-color: #fff !important;
          }
        }
        
        &.is-checked .el-checkbox__label {
          color: #c8a45c !important;
          font-weight: 600;
        }
        
        .el-checkbox__label {
          padding-left: 8Px;
          padding-top: 0;
          font-size: 14Px;
          line-height: 1.6;
          color: #606266;
        }
      }
    }
    
    /deep/.el-input__icon {
      font-size: 20Px !important;
      line-height:0.2rem;
      width: 20Px;
    }
    .form-select {
      width: 100% !important;
      
      // /deep/ .el-select__caret {
      //   font-size: 0.2rem !important;
      //   color: #c0c4cc !important;
      //   transition: transform 0.3s !important;
      //   right: 10Px !important;
      // }
      
      // /deep/ .el-input__icon {
      //   line-height: 0.1Px !important;
      //   font-size: 0.2rem !important;
      // }
      
      /deep/ .el-select.is-active .el-select__caret,
      /deep/ .el-select.is-reverse .el-select__caret {
        transform: rotate(180deg) !important;
      }
      
      /deep/ .el-input {
        position: relative;
        font-size: 14Px !important;
      }
      
      /deep/ .el-input__inner {
        height: 42Px !important;
        line-height: 42Px !important;
        font-size: 14Px !important;
        border-radius: 4Px !important;
        border: 1Px solid #dcdfe6 !important;
        padding: 0 30Px 0 14Px !important;
      }
      
      /deep/ .el-input__suffix {
        position: absolute !important;
        right: 8Px !important;
        top: 0 !important;
        height: 42Px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        line-height: 1 !important;
      }
      
      /deep/ .el-input__suffix .el-select-icon {
        transform-origin: center center !important;
        transition: transform 0.3s !important;
        line-height: 1 !important;
      }
      
      &.is-active /deep/ .el-input__suffix .el-select-icon,
      &.is-reverse /deep/ .el-input__suffix .el-select-icon {
        transform: rotate(180deg) !important;
      }
      
      &.is-active /deep/ .el-input__suffix,
      &.is-reverse /deep/ .el-input__suffix {
        top: 0 !important;
        height: 42Px !important;
        transform: none !important;
      }
    }
    
    .phone-input-wrapper {
      display: flex;
      gap: 12Px;
      
      .phone-code-select {
        width: 180Px !important;
        flex-shrink: 0;
        
        /deep/ .el-input__inner.is-disabled {
          background-color: #f5f7fa;
          color: #606266;
          -webkit-text-fill-color: #606266;
        }
        
        /deep/ .el-input-group__prepend {
          background-color: #f5f7fa;
          color: #606266;
          border-color: #dcdfe6;
        }
      }
      
      .phone-number-input {
        flex: 1;
      }
    }
    
    .submit-btn {
      display: block;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border: none;
      color: #fff;
      font-size: 16Px;
      font-weight: 500;
      border-radius: 8Px;
      padding: 14Px 60Px;
      margin: 40Px auto;
      cursor: pointer;
      box-shadow: 0 4Px 16Px rgba(102, 126, 234, 0.4);
      transition: all 0.3s;
      
      &:hover {
        transform: translateY(-2Px);
        box-shadow: 0 6Px 20Px rgba(102, 126, 234, 0.5);
      }
      
      &:active {
        transform: translateY(0);
      }
    }
  }
}
</style>
